import { generateDefaultSelectors } from "@/redux/selectors.utils";
import { IState } from "@/redux/store.types";
import { getApiDataState } from "@/redux/utils";

import { $CheckUserModuleName } from "./checkUser.types";

const { isLoading } = generateDefaultSelectors($CheckUserModuleName);

const doesUserExist = (state: IState) =>
    !getApiDataState(state, $CheckUserModuleName)?.error;

const fetchUserUrl = (state: IState) => {
    const checkUserState = getApiDataState(state, $CheckUserModuleName);
    return !checkUserState?.error && checkUserState?.params
        ? checkUserState.params.path.url
        : "";
};

export { doesUserExist, fetchUserUrl, isLoading };
